import { DataTable, type Column } from '@/components/data/DataTable'
import { cellText, findingColumns, type Finding } from '@/lib/findings'

const ID_LIKE = /(^id$|_id$|^key$|_key$|Id$|Key$|^self$)/

type Indexed = { row: Finding; i: number }

/**
 * A read-only operation's findings on the dense DataTable. Row id = the row's index.
 * Columns are the union of keys across rows; every cell truncates with its full value
 * in the tooltip.
 */
export function FindingsTable({ findings, selectedId = null, onSelect }: {
  findings: Finding[]
  selectedId?: string | null
  onSelect?: (id: string) => void
}) {
  const indexed: Indexed[] = findings.map((row, i) => ({ row, i }))
  const columns: Column<Indexed>[] = findingColumns(findings).map((k) => {
    const sample = findings.find((r) => r[k] !== null && r[k] !== undefined)?.[k]
    return {
      key: k,
      header: k,
      mono: ID_LIKE.test(k) || typeof sample === 'number' || typeof sample === 'object',
      title: (r) => cellText(r.row[k]) || undefined,
      render: (r) => cellText(r.row[k]),
    }
  })
  return (
    <DataTable
      label="Findings"
      rows={indexed}
      columns={columns}
      rowId={(r) => String(r.i)}
      selectedId={selectedId}
      onSelect={onSelect}
      empty="No findings — nothing matched."
    />
  )
}
